<ng-container *ngIf="heroContent$ | async as heroContent">
    <div class="container" *ngIf="heroContent$ | async as heroContent">
        <img loading="lazy" height="450" [src]="heroContent.header.style.backgroundImage.desktop" alt="graphics" class="hero-image-desktop">
        <img loading="lazy" height="310" [src]="heroContent.header.style.backgroundImage.mobile" alt="graphics" class="hero-image-mobile">

        <div class="content">
            <h1 [style.color]="heroContent.header.style.textColor">{{ heroContent.header.text }}</h1>
        </div>
    </div>
    <div class="description">
        <p [style.color]="heroContent.description.style.textColor">
            <ng-container
                *ngFor="let part of getHighlightedText(heroContent.description.text, heroContent.description.highlight.texts)">
                <span
                    [style.color]="part.isHighlight ? heroContent.description.highlight.style.textColor : heroContent.description.style.textColor">{{
                    part.part }} </span>
                <br *ngIf="part.isHighlight">
                <span *ngIf="part.isHighlight && isViewportLessThan600px()"><br></span>
            </ng-container>
        </p>
    </div>
</ng-container>